import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  RequestPhishBoxList,
  SuccessPhishBoxList,
  FailurePhishBoxList,
  RequestDynamicPhishingEmails,
  SuccessDynamicPhishingEmails,
  FailureDynamicPhishingEmails,
} from "../actions/phishBoxActions";

import axiosApi from "../../utils/axios";

// _source.user is ":username" from the ui, ":api:username" from the public api and the
// recipient email from the mail gateway. The public api prefix also starts with ":", check it first.
const UI_USER_PREFIX = ":";
const PUBLIC_API_USER_PREFIX = ":api:";

const getSubmitType = (user) => {
  if (user?.startsWith(PUBLIC_API_USER_PREFIX)) return "Public API";
  if (user?.startsWith(UI_USER_PREFIX)) return "UI";
  return "Email";
};

// Drops the submitter prefix from the user and from the description that contains it
const stripUserPrefix = (text) =>
  text.includes(PUBLIC_API_USER_PREFIX)
    ? text.replace(PUBLIC_API_USER_PREFIX, "")
    : text.replace(UI_USER_PREFIX, "");

const mapPhishBoxList = (list) =>
  list.map((el) => {
    const source = el._source || {};
    const desc = source.description || "";

    return {
      id: el._id,
      system: el.system,
      submitType: getSubmitType(source.user),
      date: source.time,
      link: source.target_url,
      user: source.user && stripUserPrefix(source.user),
      decision: source.decision,
      visited:
        desc === ""
          ? ""
          : desc.includes("controlled") // Artık desc'in string olduğundan eminiz
            ? "auto"
            : source.visited,
      description: stripUserPrefix(desc),
    };
  });

const mapDynamicPhishingEmails = (list) =>
  list.map((el) => {
    const source = el._source || {};
    const desc = source.description || "";
    const user = source.user || "";

    return {
      ...el,
      _source: {
        ...source,
        user: stripUserPrefix(user),
        description: stripUserPrefix(desc),
        visited: desc === "" ? "" : desc.includes("controlled") ? "auto" : source.visited,
      },
    };
  });

export function* phishBoxList() {
  try {
    const activeTab = yield select((state) => state.phishBox.phishBoxActiveTab);

    // Sekmelere göre endpoint haritası
    const endpointMap = {
      Latest: "/api/phishbox/list",
      "Not Allowed": "/api/phishbox/list/not-allowed",
      Visited: "/api/phishbox/list/visited",
    };

    const url = endpointMap[activeTab] || endpointMap["Latest"];
    const response = yield call(axiosApi.get, url);
    yield put(SuccessPhishBoxList(mapPhishBoxList(response.data)));
  } catch (e) {
    yield put(FailurePhishBoxList());
  }
}

export function* dynamicPhishingEmails() {
  try {
    const activeTab = yield select((state) => state.phishBox.dynamicPhishingActiveTab);

    // Sekmelere göre endpoint haritası
    const endpointMap = {
      Latest: "/api/phishbox/dynamic-phishing-emails",
      "Not Allowed": "/api/phishbox/dynamic-phishing-emails/not-allowed",
      Visited: "/api/phishbox/dynamic-phishing-emails/visited",
    };

    const url = endpointMap[activeTab] || endpointMap["Latest"];
    const response = yield call(axiosApi.get, url);
    const mappedData = mapDynamicPhishingEmails(response?.data?.results || []);
    yield put(SuccessDynamicPhishingEmails(mappedData));
  } catch (e) {
    yield put(FailureDynamicPhishingEmails());
  }
}

const phishBoxSagas = [
  takeLatest(RequestPhishBoxList, phishBoxList),
  takeLatest(RequestDynamicPhishingEmails, dynamicPhishingEmails),
];

export default phishBoxSagas;
